// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CreateAppSystemRequestModel from '../../model/create-app-system-request-model';
import CreateAppSystemRequestDTO from '../dto/create-app-system-request-dto';
import dtoSchema from '../schemas/create-app-system-request-schema';

export default abstract class CreateAppSystemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CreateAppSystemRequestDTO>) {
    super();
    if (data) {
      this.name = data.name;
      this.tenantKey = data.tenantKey ?? undefined;
      this.isActive = data.isActive;
    }
  }
  /**
  * @minimum 1
  */
  name?: string;
  /**
  */
  tenantKey?: string;
  /**
  */
  isActive?: boolean;

  static toModel(dto: DeepPartial<CreateAppSystemRequestDTO>): CreateAppSystemRequestModel;
  static toModel(dto: DeepPartial<CreateAppSystemRequestDTO> | undefined | null): CreateAppSystemRequestModel | undefined;
  static toModel(dto: DeepPartial<CreateAppSystemRequestDTO> | undefined | null): CreateAppSystemRequestModel | undefined {
    return dto ? new CreateAppSystemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CreateAppSystemRequestModel> | CreateAppSystemRequestModel): CreateAppSystemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      name: unwrapped.name,
      tenantKey: unwrapped.tenantKey,
      isActive: unwrapped.isActive,
    } as CreateAppSystemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CreateAppSystemRequestModel, can not map to CreateAppSystemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
